import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import PoziAPICKANAPI from 'api/ckanapi'
import LoaderHandleGeoJSON, { LoaderFailed } from 'config/LoaderHandleGeoJSON'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

export default function (layer) {
  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (_extent, _resolution, projection, success, failure) {
      if (!layer.config.spatial.url) {
        console.log('Cannot load ckanapi data without a valid url (layer.config.spatial.url).')

        failure()
        return false
      }

      window.store.dispatch(setLayerLoadInProgress(layer.titleid))
      PoziAPICKANAPI()
        .getDataAsGeoJSON(layer.config.spatial.url)
        .then(function (geojson) {
          LoaderHandleGeoJSON(geojson, projection, geojsonSource, layer, success)
        })
        .catch(function (err) {
          LoaderFailed(layer, err, failure)
        })
    },
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}
